import {invalidateQueries, q} from "../../../state";
import {
  ComplexityModelId,
  ComplexityModelVersionId,
  CreateUpdateTierAssessmentAutorun,
  TierAssessmentAutorun,
  TierAssessmentAutorunId,
} from "platformed-client/types";
import {platformedClient} from "../..";

/**
 * Create a tier assessment autorun configuration
 */
export async function create(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  data: CreateUpdateTierAssessmentAutorun,
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun",
    {path: {model_id: modelId, version_id: versionId}, body: data},
  );
  await invalidateQueries([
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityTierAutoruns.filter(modelId, versionId),
  ]);
  return res;
}

/**
 * List all tier assessment autorun configurations for a version
 */
export async function list(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
): Promise<TierAssessmentAutorun[]> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun",
    {path: {model_id: modelId, version_id: versionId}},
  );
}

/**
 * Update a tier assessment autorun configuration
 */
export async function update(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  autorunId: TierAssessmentAutorunId,
  data: CreateUpdateTierAssessmentAutorun,
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "put",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun/{autorun_id}",
    {path: {model_id: modelId, version_id: versionId, autorun_id: autorunId}, body: data},
  );
  await invalidateQueries([
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityTierAutoruns.filter(modelId, versionId),
  ]);
  return res;
}

/**
 * Delete a tier assessment autorun configuration
 */
export async function delete_(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  autorunId: TierAssessmentAutorunId,
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/autorun/{autorun_id}",
    {path: {model_id: modelId, version_id: versionId, autorun_id: autorunId}},
  );
  await invalidateQueries([
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityTierAutoruns.filter(modelId, versionId),
  ]);
  return res;
}
